import React from "react";
import { Link } from "react-router-dom";
import { Button } from "react-bootstrap";
import StepZilla from "react-stepzilla";
import PersonalInfo from "./Steps/PersonalInfo";
import CompanyInfo from "./Steps/CompanyInfo";
import SubscriptionInfo from "./Steps/SubscriptionInfo";
import BillingInfo from "./Steps/BillingInfo";
import CheckoutForm from "./Steps/CheckOutForm";
import Review from "./Steps/Review";
import { connect } from "react-redux";
import {
  registerUserAction,
  getInviteUserDetailAction,
  registerUserWithoutPlanAction,
  getStripeSettingAction,
  getBillingSettingAction,
  registerUserWithBillingAction,
} from "./../../actions/UserActions";
import { getAllSubscriptionAction } from "./../../actions/SubscriptionAction";
import { getAddressFromZipcodeAction } from "./../../actions/commonActions";
import { getMasterDatabyShortCode } from "../../actions/MasterLookUpactions.js";
import {
  cryptoTokenDecode,
  getToday,
  removeDashFromMobile,
  toastMessage,
  formatPhoneNumber,
} from "./../Common/Common";
import $ from "jquery";
import * as code from "./../../config/Constants";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import * as message from "./../../config/CommonMessages";
import { getHearAboutUsAction } from "../../actions/HearAboutUsActions";
import HeaderLogin from "../HeaderLogin/HeaderLogin";
import { getStripeKeyAction } from "./../../actions/PaymentMethodActions";
import { REACT_APP_CRYPTO_SECRET_KEY } from "../../config/Constants";
var CryptoJS = require("crypto-js");

var date = getToday();
//const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_KEY);

class Register extends React.Component {
  // Where ACCTOWNER gets read into system
  // usertype needs to be an array
  defaultState = {
    usertype: message.ACCTOWNER,
    firstname: "",
    username: "",
    lastname: "",
    email: "",
    recoveryEmail: "",
    password: "",
    companyOptions: [],
    businessOptions: [],
    hearAboutUsOptions: [],
    confirmPassword: "",
    mobileNumber: "",
    otherNumber: "",
    brokerLicenseNo: "",
    agentLicenseNo: "",
    licenseExpirationDate: date,
    agentLicenseExpirationDate: date,
    knowAboutUs: "",
    referralCode: "",
    companyInformation: {
      name: "",
      website: "http://www.",
      address: "",
      zipcode: "",
      city: "",
      state: "",
      phoneNumber: "",
      faxNumber: "",
      typeOfBusiness: "",
      companySize: "",
    },
    address: "",
    bio: "-",
    jobTitle: "",
    quote: "",
    avatar: "-",
    socialMediaHandles: {
      facebook: "",
      twitter: "",
      instagram: "",
      realtor: "",
      zillow: "",
    },
    education: [],
    certifications: [],
    awards: [],
    regMsgDisplay: false,
    agentPercent: 100.0,
    brokerPercent: 0.0,
    paymentMethodId: "",
    monthData: [],
    yearData: [],
    invoiceId: "",
    customerId: "",
    price: "",
    productName: "",
    amount: "",
    interval: "",
    paymentMethods: {
      number: "",
      expireMonth: "",
      expireYear: "",
      brand: "",
    },
    billingAddress: {
      addressLine1: "",
      addressLine2: "",
      city: "",
      state: "",
      zip: "",
      phoneNumber: "",
    },
    showNavigation: true,
    token: "",
    isBuyerAgentInviteByAdmin: false,
    authId: "",
    _id: "",
    showLoader: false,
    key: null,
    stripePromise: "",
  };

  constructor(props) {
    super(props);
    this.state = this.defaultState;
  }

  getUserData() {
    return this.state;
  }

  updateUserData(key, value, isUpdate) {
    this.setState(
      {
        [key]: value,
      },
      () => {
        if (isUpdate) {
          this.setState({ key: new Date() });
        }
      }
    );
  }

  updateUserCmpnyData(key, value) {
    var comp = this.state.companyInformation;
    comp[key] = value;
    this.setState({ companyInformation: comp });
  }
  updateSocialMediaHandles(key, value) {
    var comp = this.state.socialMediaHandles;
    comp[key] = value;
    this.setState({ socialMediaHandles: comp });
  }
  updateUserBillingData(key, value) {
    var billing = this.state.billingAddress;
    billing[key] = value;
    this.setState({ billingAddress: billing });
  }
  componentWillMount() {
    this.getReactAppStripeKey();
    // remove localstorage data if not came from pricing screen
    if (this.props.location.fromPricing == undefined) {
      localStorage.removeItem("price");
      localStorage.removeItem("interval");
    }
    //this.stripeSettingAction();
    this.billingSettingAction();
  }

  componentDidMount() {
    this.setUserData();
    if (localStorage.getItem(code.IS_BILLING_ENABLED) === "true") {
      this.getPlanDetails();
    }
    this.props.getHearAboutUsAction();
    this.props.getMasterDatabyShortCode("hearaboutus").then((res)=>{
      this.setState({
        hearAboutUsOptions:res.data || []
      })
    })
    this.props.getMasterDatabyShortCode("type_of_business").then((res) => {
      this.setState({
        businessOptions: res.data || [],
      });
    });
    // Pre-fetch Company Size options
    this.props.getMasterDatabyShortCode("company_size").then((res) => {
      this.setState({
        companyOptions: res.data || [],
      });
    })
    sessionStorage.setItem("isPassed", false);
  }

  getReactAppStripeKey() {
    this.setState({ showLoader: true });
    this.props.getStripeKeyAction().then((res) => {
      //console.log('getReactAppStripeKey getStripeKeyAction res',res);
      this.setState({ showLoader: false });
      if (res.status === code.OK) {
        var sKey = res.data;
        //console.log('getReactAppStripeKey OK sKey', sKey);
        let bytes = CryptoJS.AES.decrypt(sKey, REACT_APP_CRYPTO_SECRET_KEY);
        //console.log('getReactAppStripeKey OK bytes', bytes);
        let decryptedDataKey = bytes.toString(CryptoJS.enc.Utf8);
        //console.log('decryptedDataKey',decryptedDataKey);
        let stripePromise = loadStripe(decryptedDataKey);
        this.setState({ stripePromise });
      }
    });
  }

  getPlanDetails() {
    // this.props.getAllSubscriptionAction("month").then((monthRes) => {
    //   if (monthRes.status === code.OK) {
    //     this.setState({ monthData: monthRes.data });
    //     this.setPriceData(this.state.price);
    //   }
    // });
    // this.props.getAllSubscriptionAction("year").then((yearRes) => {
    //   if (yearRes.status === code.OK) {
    //     this.setState({ yearData: yearRes.data });
    //     this.setPriceData(this.state.price);
    //   }
    // });
  }
  /** set user data if user registered by admin */
  setUserData() {
    let token = "";
    if (this.props.match.params.token) {
      token = this.props.match.params.token;
      this.setState({ token, showLoader: true });
      localStorage.setItem("token", token);
      this.props.getInviteUserDetailAction(token).then((res) => {
        if (res.status === code.OK) {
          let resKeys = Object.keys(res.data);
          let resValues = Object.values(res.data);
          for (let i = 0; i < resKeys.length; i++) {
            if (resKeys[i] === "email") {
              this.updateUserData(resKeys[i], resValues[i].address, true);
              this.updateUserData("recoveryEmail", resValues[i].address, true);
            } else if (resKeys[i] === "subsriptionDetails") {
              this.updateUserData("price", resValues[i].priceId, true);
              this.setPriceData(resValues[i].priceId);
              localStorage.setItem("price", resValues[i].priceId, true);
            } else if (resKeys[i] === "otherNumber") {
              this.updateUserData(
                resKeys[i],
                resValues[i] == null
                  ? ""
                  : formatPhoneNumber(resValues[i].toString()),
                true
              );
            } else if (resKeys[i] === "mobileNumber") {
              this.updateUserData(
                resKeys[i],
                formatPhoneNumber(resValues[i].toString()),
                true
              );
            } else if (resKeys[i] === "agentPercentage") {
              this.updateUserData("agentPercent", resValues[i], true);
            } else if (resKeys[i] === "brokerPercentage") {
              this.updateUserData("brokerPercent", resValues[i], true);
            } else if (resKeys[i] === "companyInformation") {
              let keys = Object.keys(res.data.companyInformation);
              let values = Object.values(res.data.companyInformation);
              for (let k = 0; k < keys.length; k++) {
                if (keys[k] === "phoneNumber") {
                  this.updateUserCmpnyData(
                    keys[k],
                    formatPhoneNumber(values[k].toString())
                  );
                } else {
                  this.updateUserCmpnyData(keys[k], values[k]);
                }
              }
            } else if (resKeys[i] === "socialMediaHandles") {
              let keys = Object.keys(res.data.socialMediaHandles);
              let values = Object.values(res.data.socialMediaHandles);
              for (let k = 0; k < keys.length; k++) {
                this.updateSocialMediaHandles(keys[k], values[k]);
              }
              this.setState({ showLoader: false });
            } else {
              this.updateUserData(resKeys[i], resValues[i], true);
            }
          }
        } else {
          this.setState({ showLoader: false });
        }
      });
    } else {
      localStorage.removeItem("token");
    }
  }
  // stripeSettingAction() {
  //   this.setState({ showLoader: true });
  //   this.props.getStripeSettingAction().then((res) => {
  //     if (res.status == code.OK) {
  //       if (res.data[0].isSubscriptionEnabled) {
  //         localStorage.setItem(code.IS_STRIPE_ENABLED, "true");
  //       } else {
  //         localStorage.setItem(code.IS_STRIPE_ENABLED, "false");
  //       }
  //       this.setState({ showLoader: false });
  //     }
  //   });
  // }
  billingSettingAction() {
    this.props.getBillingSettingAction().then((res) => {
      if (res.status === code.OK) {
        if (res.data.isBillingEnabled) {
          localStorage.setItem(code.IS_BILLING_ENABLED, "true");
        } else {
          localStorage.setItem(code.IS_BILLING_ENABLED, "false");
        }
        this.setState({ showLoader: false });
      } else {
        this.setState({ showLoader: false });
      }
    });
  }
  setPriceData(priceId) {
    this.state.monthData.filter((monthData) => {
      Object.keys(monthData).forEach((v) => {
        if (v == "price") {
          let price = monthData[v].price + "";
          if (price === priceId) {
            this.setProductData(monthData);
          }
        }
      });
    });
    this.state.yearData.filter((yearData) => {
      Object.keys(yearData).forEach((v) => {
        if (v == "price") {
          let price = yearData[v].price + "";
          if (price === priceId) {
            this.setProductData(yearData);
          }
        }
      });
    });
  }
  /**
   * @desc update user data
   * @param {*} data
   */
  setProductData(data) {
    this.updateUserData("productName", data.name);
    this.updateUserData("amount", data.price.unit_amount);
    this.updateUserData("interval", data.price.recurring.interval);
  }
  componentWillReceiveProps(nextProps) {
    this.setState(nextProps);
  }

  getLastStep(step) {
    this.setState({ regMsgDisplay: false });
    if (localStorage.getItem(code.IS_BILLING_ENABLED) === "true") {
      // if (step === 0 || step === 1 || step === 2 || step === 3) {
      //   $(".saveBtn").html("Next");
      // }
      if (step === 0 || step === 1 || step === 2) {
        $(".saveBtn").html("Next");
      }

      // if (step === 3) {
      //   if (
      //     localStorage.getItem("price") === "" ||
      //     localStorage.getItem("price") == undefined
      //   ) {
      //     toastMessage(code.ERROR, message.SELECT_YOUR_PLAN);
      //     $("#prev-button").trigger("click");
      //   }
      // }
      // if (step === 4) {
      if (step === 3) {
        this.setState({ showNavigation: false });
      } else {
        this.setState({ showNavigation: true });
      }
      //if (step === 5) {
      if (step === 4) {
        $(".saveBtn").html("Confirm & Save");
      }
      //if (step === 6) {
      if (step === 5) {
        this.submitAction();
      }
    } else {
      if (step === 0 || step === 1) {
        $(".saveBtn").html("Next");
      }

      if (step === 2) {
        $(".saveBtn").html("Confirm & Register");
      }

      if (step === 3) {
        this.submitAction();
      }
    }
  }
  nextButtonClick() {
    $("#next-button").trigger("click");
  }
  perviousButtonClick() {
    $("#prev-button").trigger("click");
  }
  getPaymentData(paymentMethod) {
    this.setState((prevState) => ({
      paymentMethods: {
        ...prevState.paymentMethods,
        brand: paymentMethod.card.brand,
        expireMonth: paymentMethod.card.exp_month,
        expireYear: paymentMethod.card.exp_year,
        number: paymentMethod.card.last4,
      },
    }));
    this.setState({ paymentMethodId: paymentMethod.id });
  }

  submitAction() {
    let data = this.state;

    delete data.recoveryEmail;
    delete data.confirmPassword;
    delete data.productName;
    delete data.amount;
    delete data.interval;
    delete data.showNavigation;
    delete data.token;
    data.mobileNumber = removeDashFromMobile(data.mobileNumber);
    data.otherNumber = removeDashFromMobile(data.otherNumber);
    data.companyInformation.phoneNumber = removeDashFromMobile(
      data.companyInformation.phoneNumber
    );
    data.billingAddress.phoneNumber = removeDashFromMobile(
      data.billingAddress.phoneNumber
    );
    if (data.companyInformation.faxNumber) {
      data.companyInformation.faxNumber = removeDashFromMobile(
        data.companyInformation.faxNumber
      );
    }

    if ((data.companyInformation.website + "").trim() === "http://www.") {
      data.companyInformation.website = "";
    }

    data.agentPercentage = data.agentPercent;
    data.brokerPercentage = data.brokerPercent;

    //email should be in lowercase while sending to api
    data.email = data.email.toLowerCase();

    delete data.agentPercent;
    delete data.brokerPercent;
    delete data.monthData;
    delete data.yearData;
    delete data.regMsgDisplay;
    if (!this.state.isBuyerAgentInviteByAdmin) {
      delete data.isBuyerAgentInviteByAdmin;
      delete data.authId;
      delete data._id;
    }
    if (
      localStorage.getItem(code.IS_BILLING_ENABLED) === "true" &&
      sessionStorage.getItem(code.IS_RECAPTCHA_PASSED) === "true"
    ) {
      // console.log("data-436", data);
      this.props.registerUserWithBillingAction(data).then((res) => {
        if (this.props.status === true) {
          if (
            res.data.data &&
            res.data.data.latest_invoice &&
            !!res.data.data.latest_invoice.payment_intent &&
            res.data.data.latest_invoice.payment_intent.status ===
              "requires_payment_method"
          ) {
            toastMessage(
              code.ERROR,
              "Unable to process the card, please provide new payment details"
            );
            this.setState({
              invoiceId: res.data.data.latest_invoice.payment_intent.invoice,
              customerId: res.data.data.customer,
            });
          } else {
            this.setState(this.defaultState);
            this.props.history.push({
              pathname: "/thankyou",
              isBuyerAgentInviteByAdmin: this.state.token === "" ? false : true,
            });
            this.setState({ regMsgDisplay: true });
            localStorage.removeItem("price");
            localStorage.removeItem("interval");
          }
        } else if (res.status === code.PAYMENT_REQUIRED) {
          toastMessage(code.ERROR, res.data);
        } else {
          toastMessage(code.ERROR, res.data);
          this.setState({ regMsgDisplay: true });
        }
      });
    } else if (sessionStorage.getItem(code.IS_RECAPTCHA_PASSED) === "true") {
      this.props.registerUserWithoutPlanAction(data).then((res) => {
        if (this.props.status === true) {
          this.setState(this.defaultState);
          this.props.history.push({
            pathname: "/thankyou",
            isBuyerAgentInviteByAdmin: this.state.token === "" ? false : true,
          });
          this.setState({ regMsgDisplay: true });
        } else {
          toastMessage(code.ERROR, res.data);
          this.setState({ regMsgDisplay: true });
        }
      });
    } else {
      toastMessage(code.ERROR, "Please complete reCAPTCHA check");
    }
  }

  checkLoggedIn() {
    let userType = cryptoTokenDecode().usertype;
    if (userType !== null && userType.toUpperCase() === message.ADMIN) {
      this.props.history.push("/RegistrationRequests");
    } else {
      this.props.history.push("/artwork");
    }
  }

  handleRecaptchaCheck(value) {
    let isPassed = false;
    if (value) {
      isPassed = true;
    }
    sessionStorage.setItem("isPassed", isPassed);
  }

  render() {
    // console.log("username at register", this.state.username);
    $("#next-button").attr("tabIndex", -1);

    if (localStorage.getItem("accessToken")) {
      this.checkLoggedIn();
    }

    var cls = "multi-step multi-step-register";
    if (this.state.regMsgDisplay === true && this.props.status === true) {
      cls = "multi-step multi-step-register error";
    }

    if (this.state.regMsgDisplay === true && this.props.status === false) {
      cls = "multi-step multi-step-register error";
    }

    const steps =
      localStorage.getItem(code.IS_BILLING_ENABLED) === "true"
        ? [
            {
              name: "Personal Info",
              component: (
                <PersonalInfo
                  getUserData={() => this.getUserData()}
                  updateUserData={(k, v) => {
                    this.updateUserData(k, v);
                  }}
                  hearAboutUs={this.state.hearAboutUsOptions}
                />
              ),
            },
            {
              name: "Studio Info",
              component: (
                <CompanyInfo
                  getUserData={() => this.getUserData()}
                  updateUserDetails={(k, v) => {
                    this.updateUserData(k, v);
                  }}
                  updateUserData={(k, v) => {
                    this.updateUserCmpnyData(k, v);
                  }}
                  getCityState={(zip) =>
                    this.props.getAddressFromZipcodeAction(zip)
                  }
                  companyoptions={this.state.companyOptions}
                  businessoptions={this.state.businessOptions}
                />
              ),
            },

            // {
            //   name: "Plan Info",
            //   component: (
            //     <SubscriptionInfo
            //       getUserData={() => this.getUserData()}
            //       monthData={this.state.monthData}
            //       yearData={this.state.yearData}
            //       updateUserData={(k, v) => {
            //         this.updateUserData(k, v);
            //       }}
            //     />
            //   ),
            // },
            {
              name: "Billing Info",
              component: (
                <BillingInfo
                  getUserData={() => this.getUserData()}
                  updateUserData={(k, v) => {
                    this.updateUserBillingData(k, v);
                  }}
                  getCityState={(zip) =>
                    this.props.getAddressFromZipcodeAction(zip)
                  }
                  getPaymentData={(data) => {
                    this.getPaymentData(data);
                  }}
                />
              ),
            },
            {
              name: "Payment Info",
              component: (
                <Elements stripe={this.state.stripePromise}>
                  <CheckoutForm
                    getPaymentData={(data) => {
                      this.getPaymentData(data);
                    }}
                    nextButtonClick={this.nextButtonClick}
                    perviousButtonClick={this.perviousButtonClick}
                    getUserData={() => this.getUserData()}
                  />
                </Elements>
              ),
            },
            {
              name: "Review",
              component: (
                <Review
                  getUserData={() => this.getUserData()}
                  handleRecaptchaCheck={this.handleRecaptchaCheck}
                />
              ),
            },
          ]
        : [
            {
              name: "Personal Info",
              component: (
                <PersonalInfo
                  getUserData={() => this.getUserData()}
                  updateUserData={(k, v) => {
                    this.updateUserData(k, v);
                  }}
                  hearAboutUs={this.state.hearAboutUsOptions}
                />
              ),
            },
            {
              name: "Studio Info",
              component: (
                <CompanyInfo
                  getUserData={() => this.getUserData()}
                  updateUserDetails={(k, v) => {
                    this.updateUserData(k, v);
                  }}
                  updateUserData={(k, v) => {
                    this.updateUserCmpnyData(k, v);
                  }}
                  getCityState={(zip) =>
                    this.props.getAddressFromZipcodeAction(zip)
                  }
                  companyoptions={this.state.companyOptions}
                  businessoptions={this.state.businessOptions}
                />
              ),
            },
            {
              name: "Review",
              component: (
                <Review
                  getUserData={() => this.getUserData()}
                  handleRecaptchaCheck={this.handleRecaptchaCheck}
                />
              ),
            },
          ];

    return (
      <>
        {this.state.showLoader && (
          <div className="page-loader">
            <div className="page-loader-inner">
              <div className="spinner-border" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </div>
          </div>
        )}
        <div className="reg-page">
          <HeaderLogin />
          <div className="loginBg">
            <div className="step-progress">
              <div className="reg-title-wrapper">
                <h4 className="title-big mt-0 pt-2">Register</h4>
              </div>

              <div className={cls}>
                <StepZilla
                  steps={steps}
                  // showNavigation={true}
                  backButtonCls="btn btn-sm btn-primary btn-blue btn-outlined w-140 mr-3"
                  nextButtonCls="btn btn-sm btn-primary btn-blue w-140 saveBtn"
                  onStepChange={(step) => this.getLastStep(step)}
                  showNavigation={this.state.showNavigation}
                  //hocValidationAppliedTo={[0, 1, 3]}
                  hocValidationAppliedTo={
                    localStorage.getItem(code.IS_BILLING_ENABLED) === "true"
                      ? [0, 1, 2]
                      : [0, 1, 3]
                  }
                  key={this.state.key}
                />
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    status: state.reducer.status,
    RegMessage: state.reducer.RegMessage,
    hearAboutUs: state.reducer.hearAboutUs,
  };
};

export default connect(
  mapStateToProps,
  {
    registerUserAction,
    getAddressFromZipcodeAction,
    getAllSubscriptionAction,
    getInviteUserDetailAction,
    registerUserWithoutPlanAction,
    getStripeSettingAction,
    getHearAboutUsAction,
    getBillingSettingAction,
    registerUserWithBillingAction,
    getStripeKeyAction,
    getMasterDatabyShortCode
    
  }
)(Register);
